/**
 * Created by jonlazarini on 12/05/17.
 */
import React from 'react';

export const Error = ({error}) => (<p>{error}</p>);



// WEBPACK FOOTER //
// ./src/components/Error/index.js